import { MainMenuList, MenuOpenTypeEnum, MenuSetting, MenuTemplateComponentEnum } from '@/hooks/query/athena/types';
import { BehaviorSubject, Subject } from 'rxjs';

const onClickMenuItem$ = new Subject<MainMenuList>();
const clickMenuItem = (value: MainMenuList) => onClickMenuItem$.next(value);

const isBlockRouterDetection$ = new BehaviorSubject(false);
const setIsBlockRouterDetection = (isShow: boolean) => isBlockRouterDetection$.next(isShow);

/**
 * 取得 tab 識別符
 * @returns ex. 'Tab01' or 'Tab04-Sub03'
 */
const getTabIdentifier = (tabName: string, parentTabName?: string) =>
	parentTabName ? `${parentTabName}-${tabName}` : tabName;

const getActiveTabSetting = (activeTab: string, mainMenuList: MainMenuList[] = []) => {
	const [mainTabName, subTabName] = activeTab.split('-');

	const mainSetting = mainMenuList.find(menu => menu.TabName === mainTabName);

	if (!mainSetting) return undefined;

	return subTabName
		? mainSetting.SubMenuList.find(menu => menu.TabName === subTabName)
		: mainSetting;
}

const hasTemplateComponent = (menu: MenuSetting | undefined, component: MenuTemplateComponentEnum) => {
	return menu?.OpenType === MenuOpenTypeEnum.Inner && menu.TemplateComponents?.includes(component);
}

export const athenaMenuService = {
	onClickMenuItem: onClickMenuItem$.asObservable(),
	clickMenuItem,
	isBlockRouterDetection: isBlockRouterDetection$.asObservable(),
	setIsBlockRouterDetection,
	getTabIdentifier,
	getActiveTabSetting,
	hasTemplateComponent
};